var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRewardsTrophy = function SvgRewardsTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 0h40v40H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RewardsTrophy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-562-729H878v3954H-562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-562-128H878v482H-562z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#RewardsTrophy_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -32,
    width: 381,
    height: 290,
    rx: 10,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#03C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.333 9.372H27.88A2.013 2.013 0 0 0 26 8.04H14a2.013 2.013 0 0 0-1.88 1.333H8.667A.667.667 0 0 0 8 10.04v4.333a2.027 2.027 0 0 0 1.453 1.92l3.667 1.053a17.154 17.154 0 0 0 2.213 4 3.386 3.386 0 0 0 1.773 1.2l-.973 4.134H14.96a1.973 1.973 0 0 0-1.894 1.333l-1.026 3.08a.64.64 0 0 0 .32.804c.095.048.2.074.307.076h14.666a.693.693 0 0 0 .547-.28.64.64 0 0 0 .08-.6l-1.027-3.053a1.973 1.973 0 0 0-1.893-1.334h-1.174l-.973-4.133a3.387 3.387 0 0 0 1.773-1.2 17.16 17.16 0 0 0 2.214-4l3.666-1.053A2.027 2.027 0 0 0 32 14.399v-4.333a.666.666 0 0 0-.667-.694Zm-21.52 5.64a.667.667 0 0 1-.48-.64v-3.666H12v.666c.005 1.501.21 2.994.613 4.44l-2.8-.8Zm15.853 13.48.747 2.213H13.586l.747-2.213a.667.667 0 0 1 .627-.453h10.08a.667.667 0 0 1 .626.453Zm-8.16-1.787.934-4h3.12l.933 4h-4.986Zm6.094-6.133a1.986 1.986 0 0 1-1.6.8h-4a1.987 1.987 0 0 1-1.6-.8 15.466 15.466 0 0 1-3.067-9.2V10.04A.667.667 0 0 1 14 9.372h12a.667.667 0 0 1 .666.667v1.333a15.467 15.467 0 0 1-3.066 9.2Zm7.066-6.2a.666.666 0 0 1-.48.64l-2.8.8c.403-1.446.609-2.939.614-4.44v-.666h2.666v3.666Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 377,
    height: 286,
    rx: 8,
    stroke: "#03C8B0",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RewardsTrophy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-562 -729)",
    d: "M0 0h1440v3954H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "RewardsTrophy_svg__b",
    x: -32,
    y: -32,
    width: 385,
    height: 294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0117647 0 0 0 0 0.784314 0 0 0 0 0.690196 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13219_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_13219_804",
    result: "shape"
  })))));
};

export default SvgRewardsTrophy;